import { IColumn } from "@fluentui/react";
import {
  renderLastModifiedBy,
  renderFeatureNameAndDescription,
} from "../experimentTableRenderers";
import { ExperimentType } from "../../Types";
import {
  addSortPropsToColumn,
  ColumnSortState,
} from "../../Shared/shared.utils";
import { renderUnArchiveAction } from "./archiveTableTableRenderers";

export function getArchiveTableColumns({
  handleUnarchive,
  sortState,
  hasAdoAccess,
  onColumnClick,
}: {
  handleUnarchive: (item: ExperimentType) => void;
  sortState: ColumnSortState;
  hasAdoAccess: boolean | undefined;
  onColumnClick?: (ev: React.MouseEvent<HTMLElement>, column: IColumn) => void;
}): IColumn[] {
  const baseColumns: IColumn[] = [
    {
      key: "featureName",
      name: "Feature Name",
      fieldName: "featureName",
      minWidth: 300,
      maxWidth: 1000,
      isResizable: true,
      onRender: renderFeatureNameAndDescription,
    },
    {
      key: "lastModifiedBy",
      name: "Last Modified By",
      fieldName: "lastModifiedBy",
      minWidth: 170,
      isResizable: true,
      onRender: renderLastModifiedBy,
      flexGrow: 1,
    },
    {
      key: "unarchive",
      name: "Unarchive",
      fieldName: "unarchive",
      minWidth: 100,
      maxWidth: 100,
      isResizable: false,
      flexGrow: 0,
      onRender: (item) =>
        renderUnArchiveAction(item, handleUnarchive, hasAdoAccess),
    },
  ];

  // Add sorting props only to sortable columns
  const sortableColumnKeys = ["featureName", "lastModifiedBy"];

  return baseColumns.map((column) =>
    sortableColumnKeys.includes(column.key)
      ? addSortPropsToColumn(column, sortState, onColumnClick)
      : column,
  );
}
